import { observer } from 'mobx-react-lite'
import { makeTextFieldClear, makeTextFieldIcon, TextField } from 'shared/ui/TextField'
import { useReviewsListContext } from 'pages/reviews/context'
import styles from './styles.module.scss'

export const TableSearch = observer(() => {
  const { search, setSearch } = useReviewsListContext()

  return (
    <div className={styles.wrap}>
      <TextField
        onChange={setSearch}
        variant={'integrated'}
        value={search}
        className={styles.search}
        InputProps={{
          placeholder: 'Search...',
        }}
        leftActions={[
          makeTextFieldIcon({
            icon: 'search',
            fontSize: 18,
            color: 'var(--content-primary-tertiary)',
            margin: '0 9px 0 4px',
          }),
        ]}
        rightActions={[
          makeTextFieldClear({
            isButton: true,
            isVisibleWithoutFocus: true,
            intent: 'passive',
          }),
        ]}
      />
    </div>
  )
})
